export type ChatSearchDatePreset = {
  key: 'thisMonth' | 'nextMonth' | 'upcoming' | 'past';
  label: string;
  startDate: string;
  endDate: string;
};

const pad = (value: number) => String(value).padStart(2, '0');

const formatDate = (date: Date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

/**
 * 公演日フィルタのプリセット範囲（今月・来月・今後・過去）を返す。
 * startDate / endDate は 'YYYY-MM-DD'（空文字は未指定）。
 */
export const buildChatSearchDatePresets = (now = new Date()): ChatSearchDatePreset[] => {
  const year = now.getFullYear();
  const month = now.getMonth();
  const monthStart = new Date(year, month, 1);
  const monthEnd = new Date(year, month + 1, 0);
  const nextMonthStart = new Date(year, month + 1, 1);
  const nextMonthEnd = new Date(year, month + 2, 0);
  const today = new Date(year, month, now.getDate());
  return [
    { key: 'thisMonth', label: '今月', startDate: formatDate(monthStart), endDate: formatDate(monthEnd) },
    { key: 'nextMonth', label: '来月', startDate: formatDate(nextMonthStart), endDate: formatDate(nextMonthEnd) },
    { key: 'upcoming', label: '今後', startDate: formatDate(today), endDate: '' },
    { key: 'past', label: '過去', startDate: '', endDate: formatDate(today) },
  ];
};

export default buildChatSearchDatePresets;
